import type { AxiosError } from 'axios';
import type * as React from 'react';
import type { Config } from '../../../../../components/ladda-react';
import { withData as pureWithData } from '../../../../../components/ladda-react';
import { ApiExceptionInline } from '../../components/ErrorProvider';

export function withData<InjectedProps, ResolverArguments, ErrorType = any>(
    conf: Config<InjectedProps, ResolverArguments, ErrorType>
) {
    return pureWithData<InjectedProps, ResolverArguments, ErrorType>({
        errorComponent: ApiExceptionInline,
        ...conf,
    });
}

withData.PAGINATION = pureWithData.PAGINATION;

export const handleApiErrors =
    <InitialProps, ErrorResponseData extends { message: string }>(
        handler: {
            [key: string]: React.ComponentType<InitialProps & { error: ErrorResponseData }>;
        },
        DefaultError: React.ComponentType<{ errorCode: number }>
    ): React.ComponentType<InitialProps & { error: AxiosError<ErrorResponseData> }> =>
    props => {
        const response = props.error.response!;
        const data: ErrorResponseData = response.data;
        const Component = handler[data.message];
        return Component ? <Component {...props} error={data} /> : <DefaultError errorCode={response.status} />;
    };
